import React from 'react';
import { TCN_COLOR_MAP } from './tokens';

/**
 * TCN StatusDot — 8×8 circle with glow box-shadow.
 *
 * Props:
 *  - color: semantic key or CSS color (default 'green')
 *  - size: px (default 8)
 *  - pulse: boolean (default false)
 */
const StatusDot = ({
  color = 'green',
  size = 8,
  pulse = false,
  className = '',
  style,
  ...rest
}) => {
  const c = TCN_COLOR_MAP[color] ?? color;
  return (
    <span
      aria-hidden="true"
      className={`inline-block flex-shrink-0 ${pulse ? 'animate-pulse-live' : ''} ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: c,
        boxShadow: `0 0 8px ${c}`,
        ...style,
      }}
      {...rest}
    />
  );
};

export default StatusDot;
